import { ShowFile } from './../../../services/show-file';
import { Component, OnInit } from '@angular/core';
import { BaseComponentService } from '../../../services/base-component.service';
import { AslibModalComponent, IAslibModalOptions } from '@aslib/modal';
import { CloseModal, ExportTypes } from '../../../shared/enum/shared.enum';
import { FiltroRelLiquidacao } from '../../../models/pagamento/filtro-rel-liquidacao';
import { Subject } from 'rxjs/Subject';
import { RelatorioLiq } from '../../../models/pagamento/relatorioliq';



@Component({
  selector: 'gpa-rel-liquidacao',
  templateUrl: './rel-liquidacao.component.html',
  providers: [BaseComponentService]
})
export class RelLiquidacaoComponent extends BaseComponentService implements OnInit {
  protected aslibModal: AslibModalComponent;
  _service: any;
  aslibLoadingService: any;
  subscription: any;
  showFile: ShowFile;

  filtro: FiltroRelLiquidacao;

  listagem: RelatorioLiq[];

  itemSelecionado: RelatorioLiq;

  itensSelecionados = [];

  disabledBtnExportRel: boolean;

  public static updateList: Subject<any> = new Subject();

  projetoIntegrado: string
    
  ngOnInit() {
    this.projetoIntegrado = sessionStorage.getItem('ProjetoIntegrado');

    this.showFile = new ShowFile();

    this.filtro = new FiltroRelLiquidacao(this.projetoIntegrado);

    this.listagem = [];

    this.disabledBtnExportRel = true;

    RelLiquidacaoComponent.updateList.subscribe(data => {
      this.fecharModal();

      if (data === CloseModal.Confirma) {
        this.carregarDados();
      }

    });
  }

  /*
   * Exibir a tela para definição do filtro de consulta.
   */
  definirFiltro(conteudo: any) {
    const options: IAslibModalOptions = {
      title: 'Filtro',
      backdrop: 'static',
      footerVisible: false,
      size: 'lg',
      content: conteudo
    };

    this.aslibModal.open(options).result.then(
      () => { },
      () => { }
    );
  }

  /*
   * Exibir a tela de detalhes da liquidação selecionada.
   */
  exibirDetalhes(conteudo: any, item: any) {
    this.itemSelecionado = item;

    const options: IAslibModalOptions = {
      title: 'Detalhes da Liquidação',
      backdrop: 'static',
      footerVisible: true,
      size: 'lg',
      content: conteudo
    };

    this.aslibModal.open(options).result.then(
      () => { },
      () => { }
    );
  }

  /*
   * Carregar dados para a listagem no grid.
   */
  carregarDados() {
    const rota = '/api/Relatorio/ObterListagem';
    const params = 'filtro?'.concat(this.montarParamsFiltro());

    this.itensSelecionados = [];

    this.aslibLoadingService.start();

    this._service.routePrefix = rota.concat(`/${params}`);
    this.subListar = this._service.getAll('gpa').subscribe((data: any[]) => {

      this.listagem = data;
   
      this.aslibLoadingService.complete();

        if (!this.listagem || this.listagem.length == 0) {
          this.disabledBtnExportRel = true;
          this.exibirAviso('Não foi encontrado nenhum registro que atenda ao filtro de consulta.');
        } else {
          this.disabledBtnExportRel = false;
        }
    },
      (error) => {
        this.aslibLoadingService.complete();
        this.exibirErro(error);
      },
      () => {
      }
    );
  }

  /*
  * Monta a string de parametros da URL com base nos dados do filtro.
  * Serão considerados apenas aqueles que tiveram dados espeficicados.
  * Os demais serão ajustados num método da API no lado servidor.
  */
  montarParamsFiltro(): string {
    let params = 'codigoProjeto='.concat(this.filtro.codigoProjeto);

    params = params.concat('&dataInicial='.concat(this.filtro.dataInicial.toString()).concat(
      '&dataFinal=').concat(this.filtro.dataFinal.toString()));

    params = params.concat(this.montarParametrosEscopo('escopoNumeroPed', this.filtro.escopoNumeroPed,
      'numeroPedInicial', this.filtro.numeroPedInicial, 'numeroPedFinal', this.filtro.numeroPedFinal));

    params = params.concat(this.montarParametrosEscopo('escopoNumeroEmp', this.filtro.escopoNumeroEmp,
      'numeroEmpInicial', this.filtro.numeroEmpInicial, 'numeroEmpFinal', this.filtro.numeroEmpFinal));

    params = params.concat(this.montarParametrosEscopo('escopoNumeroLiq', this.filtro.escopoNumeroLiq,
      'numeroLiqInicial', this.filtro.numeroLiqInicial, 'numeroLiqFinal', this.filtro.numeroLiqFinal));

    params = params.concat(this.isEmpty(this.filtro.numeroProcessoSei)
      ? '' : '&numeroProcessoSei='.concat(this.filtro.numeroProcessoSei));

    params = params.concat(this.isEmpty(this.filtro.historico)
      ? '' : '&historico='.concat(this.filtro.historico));

    params = params.concat(this.montarParametrosTipoCredor('tipoInformacaoCredor', this.filtro.tipoInformacaoCredor,
      'informacaoCredor', this.filtro.informacaoCredor));

    params = params.concat(this.montarParametrosTipoCredor('tipoInformacaoCredorConsignataria', this.filtro.tipoInformacaoCredorConsignataria,
      'informacaoCredorConsignataria', this.filtro.informacaoCredorConsignataria));

    params = params.concat(this.montarParametrosEscopo('escopoValorLiq', this.filtro.escopoValorLiq,
      'valorLiqInicial', this.filtro.valorLiqInicial, 'valorLiqFinal', this.filtro.valorLiqFinal));

    return params;
  }

  /*
   *  Monta os parametros referentes ao tipo escopo (igual ou intervalo)
   */
  montarParametrosEscopo(atributoEscopo: string, valorEscopo: number,
    atributoInicial: string, valorInicial: any, atributoFinal: string, valorFinal: any) {

    // se não especificou o escopo não insere nada.
    if (valorEscopo === 0) {
      return '';
    }

    valorInicial += '';
    valorFinal += '';

    // se o escopo for "igual" sempre terá o escopo e o valor inicial como parametros.
    let parametros = '&'.concat(atributoEscopo.concat('=').concat(
      valorEscopo.toString()).concat('&').concat(atributoInicial.concat('=').concat(valorInicial)));

    // se o escopo for "intervalo" terá também o valor final como parametro.
    if (valorEscopo === 2) {
      parametros = parametros.concat('&').concat(atributoFinal).concat('=').concat(valorFinal);
    }

    return parametros;
  }

  montarParametrosTipoCredor(atributoTipoCredor: string, valorTipoCredor: number,
    atributoConteudo: string, valorConteudo: string) {

    // se não especificou o tipo não insere nada.
    if (valorTipoCredor === 0) {
      return '';
    }

    const parametros = '&'.concat(atributoTipoCredor.concat('=').concat(
      valorTipoCredor.toString()).concat('&').concat(atributoConteudo.concat('=').concat(valorConteudo)));

    return parametros;

  }

  /*
   * Gerar e efetuar o download do relatório inddividual para cada registro selecionado.
   */
  gerarRelatorioIndividual(item: RelatorioLiq, tipoExportado: ExportTypes) {
    item.tipoExportacao = tipoExportado;
    let nomearquivo = 'RelatorioLiquidacao' + item.numeroLiq + item.numeroProcessoSei;
    this._service.routePrefix = '/api/Relatorio/gerarRelatorioLiquidacaoIndividual';
    
    this.aslibLoadingService.start();

    this.subscription = this.gerarRelatorio(item, tipoExportado, 'gpa').subscribe(res => {
      this.showFile.windows(res, tipoExportado, nomearquivo);
    },
      (error: any) => {
        this.exibirErro(error);
      },
      () => {
        this.unSubscribe();
      }
    );

  }
   
  onCheckboxGrid($event) {
        
    const [id, seq, procSei] = $event.target.id.replaceAll(".", "").replaceAll("-", "").split("|");
      const isChecked = $event.target.checked;

      // Localiza o item na listagem
      const item = this.listagem.find(x => x.numeroLiq == id && x.seqItem == seq && x.numeroProcessoSei == procSei);

      if (!item) return;

    let index: number;


      if (isChecked) {
        // Adiciona se não existir
        if (!this.itensSelecionados.some(x => x.numeroLiq == id && x.seqItem == seq && x.numeroProcessoSei == procSei)) {
          this.itensSelecionados.push(item);
        }
        item.selecionado = true;
      } else {
        // Remove se existir
        this.itensSelecionados = this.itensSelecionados.filter(x => !(x.numeroLiq == id && x.seqItem == seq && x.numeroProcessoSei == procSei));
        item.selecionado = false;
      }
  }

  onCheckboxSelectAll($event) {
    const isChecked = $event.target.checked;
    let index: number;
    if(isChecked)
      this.itensSelecionados = [];

    this.listagem.forEach(item => {

      index = this.itensSelecionados.findIndex(x => x.numeroLiq == item.numeroLiq);

      if (index > -1 && !isChecked) {
        this.itensSelecionados.splice(index, 1);
        item.selecionado = false;
      }

      if (item.numeroLiq == item.numeroLiq && isChecked) {
        this.itensSelecionados.push(item);
        item.selecionado = true;
      }

    });
console.log(this.itensSelecionados);
console.log(this.listagem);

  }

  showModalConfirm(conteudo: any, titulo: string) {
    const options: IAslibModalOptions = {
      type: 'default',
      title: titulo,
      backdrop: 'static',
      cancelarVisible: true,
      size: 'lg',
      content: conteudo,
      okVisible : true,
      okText : 'Ok'
    };

    // Carrega um modal para exibição de mansagem
    this.aslibModal.open(options).result.then(
      () => {debugger; },
      () => { }
    );
  }


  baixarRelatorio(tipo: string) {

    let tipoExportado: ExportTypes = tipo == 'Excel' ? ExportTypes.Excel_xls : ExportTypes.PDF;
    let i = 0;
    let intervalo: any;


    if (this.itensSelecionados.length == 0) {
      this.exibirAviso('Nenhum item foi selecionado! Favor selecionar na lista.');
      return;
    }

    this.itensSelecionados.forEach(item => {
      item.tipoExportacao = tipoExportado;
    });


    this.relatorioLote(this.itensSelecionados, ExportTypes.ZIP);

    // Fila com intervalo de 10 seg
    //intervalo = setInterval(() => { this.itemFila(i, tipoExportado, this.itensSelecionados, intervalo); i++; }, 10000);
  }

  itemFila(proximo: number, tipoExportado: ExportTypes, itens: any, intervalo: any) {

    if (proximo <= (itens.length - 1)) {
      this.relatorioIndividual(itens[proximo], tipoExportado);
    }

    if (proximo > itens.length) {
      clearInterval(intervalo);
      console.log("Proximo: ", proximo, intervalo);
    }

  }

  relatorioLote(itens: any, tipoExportado: ExportTypes) {
    
    this._service.routePrefix = '/api/Relatorio/BaixarRelatorioLiquidacaoLote';

    if (itens == null) {
      return;
    }
    
    this.aslibLoadingService.start();

    this.subscription = this.gerarRelatorio(itens, tipoExportado, 'gpa').subscribe(res => {
            
      // Pega o timestamp atual
      const timestamp = Date.now();

      // Converte para objeto Date
      const dateObj = new Date(timestamp);

      // Extrai data e hora separadas
      const data = dateObj.toLocaleDateString('pt-BR').replace('/', '').replace('/', ''); // Ex.: 10/12/2025
      const hora = dateObj.toLocaleTimeString('pt-BR').replace(':', '').replace(':', ''); // Ex.: 15:42:10

      this.showFile.download(res, tipoExportado, 'LIQs_' +data+'_'+ hora+".zip");
    },
      (error: any) => {
        this.exibirErro(error);
      },
      () => {
        this.unSubscribe();
      }
    );

  }

  relatorioIndividual(item: RelatorioLiq, tipoExportado: ExportTypes) {
    item.tipoExportacao = tipoExportado;

    this._service.routePrefix = '/api/Relatorio/gerarRelatorioLiquidacaoIndividual';


    if (item == null) {
      return;
    }

    this.aslibLoadingService.start();

    this.subscription = this.gerarRelatorio(item, tipoExportado, 'gpa').subscribe(res => {
      this.showFile.download(res, tipoExportado, 'Liq_' + Date.now());
    },
      (error: any) => {
        this.exibirErro(error);
      },
      () => {
        this.unSubscribe();
      }
    );

  }

  /*
  * Exportar a listagem para um relatório no formato PDF. 
  */
  exportarRelatorioPdf() {
    this.emitirRelatorio(ExportTypes.PDF);
  }

  /*
 * Exportar a listagem para um relatório no formato informado.
 */
  emitirRelatorio(tipoExportado: ExportTypes) {
    // define o tipo de relatório para ser passado no parâmetro de filtro a ser lido pela api.
    this.filtro.tipoExportacao = tipoExportado;

    this._service.routePrefix = '/api/Relatorio/gerarRelatorioLiquidacao';

    this.aslibLoadingService.start();

    this.subscription = this.gerarRelatorio(this.filtro, tipoExportado, 'gpa').subscribe(res => {
      this.showFile.windows(res, tipoExportado, 'RelatorioLiquidacoes');
    },
      (error: any) => {
        this.exibirErro(error);
      },
      () => {
        this.unSubscribe();
      }
    );
  }

  unSubscribe() {
    this.aslibLoadingService.complete();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pagamento/relatorios/rel-liquidacao/rel-liquidacao.component.ts